import { combineEpics } from 'redux-observable';
import { getSchedule$ } from './getSchedule$';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default combineEpics(getSchedule$);
